import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { verifyEmail } from "./authService";
import useBootstrapCSS from "../../hooks/useBootstrapCSS";
import codLogo from "./CoD-Logo.png";
import "./login.css";

const LoginEmail = () => {
    useBootstrapCSS();
    const [email, setEmail] = useState("");
    const [message, setMessage] = useState({ text: "", type: "" });
    const navigate = useNavigate();

    useEffect(() => {
        const logoutReason = sessionStorage.getItem("logoutReason");
        if (logoutReason) {
            setMessage({ text: logoutReason, type: "fail" });
            sessionStorage.removeItem("logoutReason");
        }
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setMessage({ text: "", type: "" });

        try {
            const result = await verifyEmail(email);
            if (result.redirect) {
                navigate("/login-password", { state: { email } });
            } else {
                setMessage({ text: result.message || "Something went wrong", type: "fail" });
            }
        } catch (error) {
            setMessage({ text: error.message, type: "fail" });
        }
    };

    return (
        <section className="login-page">
            <div className="container-fluid">
                <div className="row align-items-center h-100">
                    <div className="col-md-6 col-sm-12 px-5 left-graphic">
                        <img src={codLogo} className="img-fluid" alt="CoD Logo" />
                    </div>

                    <div className="col-md-6 col-sm-12 px-5 form-outer h-100 align-items-center d-flex flex-column justify-content-center">
                        <form className="initial-form" onSubmit={handleSubmit}>
                            <h3 className="h3 mb-3">Login</h3>
                            <div className="form-group mb-20">
                                <label htmlFor="loginEmail">User Name</label>
                                <input
                                    type="email"
                                    className="form-control"
                                    id="loginEmail"
                                    placeholder="User Name"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    required
                                />
                            </div>
                            <div className="w-100 d-inine">
                                <button type="submit" className="btn btn-primary mb-20">
                                    Continue
                                </button>
                            </div>

                            {message.text && (
                                <div className={`message ${message.type === "success" ? "successmessage" : "failmessage"}`}>
                                    {message.text}
                                </div>
                            )}
                        </form>
                        <div className="form-footer">
                            <div className="d-flex justify-content-center">
                                <p className="text-muted">
                                    Don't have an account?{" "}
                                    <a href="/signup">SignUp here</a>
                                </p>
                            </div>
                            <p>Copyright &copy; {new Date().getFullYear()} Compliance on Demand. All Rights Are Reserved.</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default LoginEmail;
